// extracted by mini-css-extract-plugin
module.exports = {"MainPanner":"MainPanner__MainPanner__2chNN","Info":"MainPanner__Info__1q1X5"};